// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload-action[data-v-0cffb375]{width:150px;height:150px}.file-container[data-v-0cffb375]{min-height:100px;padding-bottom:50px;border:1rem}.tips[data-v-0cffb375]{border:5px;padding:5px}.tips p[data-v-0cffb375]{font-size:large;font-weight:700}.tip li[data-v-0cffb375]{padding-block-start:1rem;font-size:medium;font-weight:400;font-family:Times New Roman,Times,serif}.ivu-row[data-v-0cffb375]{padding-top:10px}", ""]);
// Exports
module.exports = exports;
